/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：388
 */

"use strict"

export { o as a }
import * as /* [auto-meaningful-name] */Module_107 from /* 107 */"./107"
import * as /* [auto-meaningful-name] */Module_142 from /* 142 */"./142"
function o(e, t) {
  return !t || "object" !== Module_107.a(t) && "function" !== typeof t ? Module_142.a(e) : t
}
export default o
